import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { ActionIcon, Container, Text } from "@mantine/core";
import { useEffect, useState } from "react";

import { useAnalytics } from "@/analytics";
import { CloseX } from "@/common-ui";
import { useLogger } from "@/sdk/logging/LoggerProvider";

import { BaseNotification } from "../BaseNotification/BaseNotification";
import { type CelebrationNotificationType, defaultReactions, optionalReactions } from "../models";
import styles from "./CelebrationNotification.module.css";

export function CelebrationNotification({
    reactionType,
    sender,
    onClose,
}: CelebrationNotificationType["props"] & { onClose: () => void }) {
    const logger = useLogger({ module: "CelebrationNotification", supportTeam: "sales" });
    const { dispatcher } = useAnalytics();
    const reactionsToRender = [...defaultReactions, ...optionalReactions];
    const chosenReaction = reactionsToRender.find((r) => r.id === reactionType);
    const [isClosing, setIsClosing] = useState(false);
    setTimeout(() => setIsClosing(true), 5000);
    useEffect(() => {
        void dispatcher.dispatchBusinessEvent("CelebrationNotificationReceived", { reactionType, sender });
        logger.info({ reactionType, sender }, "CelebrationNotificationReceived");
        // oxlint-disable-next-line exhaustive-deps
    }, []);

    return (
        <BaseNotification onClose={onClose} isClosing={isClosing} side="right" width="21rem">
            {chosenReaction && <Text>{chosenReaction.value}</Text>}
            <Text c="dark.1" fw={700} size="sm">
                {sender} said congrats on the sale!
            </Text>
            <ActionIcon onClick={() => setIsClosing(true)} ml="0" mr={0} bg="transparent">
                <CloseX fill="var(--mantine-color-primary-1)" />
            </ActionIcon>
            {chosenReaction && (
                <Container className={styles.reactionOverlay}>
                    <DotLottieReact src={chosenReaction.animationPath} autoplay speed={1} loop />
                </Container>
            )}
        </BaseNotification>
    );
}
